import { inject } from '@angular/core'
import { HttpInterceptorFn } from '@angular/common/http'
import { from, switchMap } from 'rxjs'
import { AuthService } from './auth.service'
import { environment } from '../../../environments/environment'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService)

  if (!environment.apiUrl || !req.url.startsWith(environment.apiUrl)) {
    return next(req)
  }

  return from(authService.getIdToken()).pipe(
    switchMap((token) => {
      if (token) {
        const authedReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        })
        return next(authedReq)
      }
      return next(req)
    })
  )
}
